import { getLanguageConfig, getUrlForDownload } from "@/api/app";
import {
  ADD_APP_RECENTLY_PLAYED,
  SAVE_APP_LANGUAGE,
  SAVE_APP_LANGUAGE_CONFIG,
  SET_APP_CONFIG,
  SET_APP_DOWNLOADurl
} from "@/store/mutation_types";
import { getDeviceType } from "@/utils/index.js";
import { getLanguage, getLocalLanguage } from "@/lang";

function getRecentlyPlayed() {
  let recentlyPlayed = localStorage.getItem("recently-played");
  if (recentlyPlayed) {
    try {
      recentlyPlayed = JSON.parse(recentlyPlayed);
    } catch (e) {
      console.log(e);
    }
  }
  return recentlyPlayed || [];
}

const sysDict = {
  state: {
    downloadURl: "",
    appConfig: {},
    recentlyPlayed: getRecentlyPlayed(),
    appLanguageConfig: [
      { name: "中文", code: "zh_CN" },
      { name: "English", code: "en_US" }
    ],
    appLanguage: getLocalLanguage()
  },
  getters: {
    appDownloadURl: state => state.downloadURl,
    appConfig: state => state.appConfig,
    recentlyPlayed: state => state.recentlyPlayed,
    appLanguageConfig: state => state.appLanguageConfig,
    appLanguage: state => {
      if (state.appLanguage) {
        return state.appLanguage;
      }
      const code = getLanguage();
      return (
        state.appLanguageConfig.find(language => {
          return language.code === code;
        }) || {}
      );
    }
  },
  mutations: {
    [SET_APP_DOWNLOADurl]: (state, data) => {
      state.downloadURl = data;
    },
    [SET_APP_CONFIG]: (state, data) => {
      state.appConfig = data;
    },
    [ADD_APP_RECENTLY_PLAYED]: (state, data) => {
      const recentlyPlayed = state.recentlyPlayed.filter(item => {
        return item.id !== data.id;
      });
      recentlyPlayed.unshift(data);
      state.recentlyPlayed = recentlyPlayed;
      localStorage.setItem("recently-played", JSON.stringify(recentlyPlayed));
    },
    [SAVE_APP_LANGUAGE_CONFIG](state, playload = []) {
      state.appLanguageConfig = playload;
    },
    [SAVE_APP_LANGUAGE](state, code) {
      const language = state.appLanguageConfig.find(language => {
        return language.code === code;
      });
      if (language) {
        localStorage.setItem("language", JSON.stringify(language));
      } else {
        localStorage.clear("language");
      }
      state.appLanguage = language;
    }
  },
  actions: {
    // 获取下载app的Url
    async getUrlForDownload({ commit, state }, playload) {
      if (state.downloadURl) {
        return state.downloadURl;
      }
      const rRes = await getUrlForDownload({
        type: getDeviceType()
      });
      const downloadURl = rRes.data.data.url;
      commit(SET_APP_DOWNLOADurl, downloadURl);
      return downloadURl;
    },
    // 获取配置文件
    async getAppConfig({ getters, commit }, playload) {
      // if (isNotEmpty(getters.appConfig)) {
      //   return getters.appConfig;
      // }
      const config = await this._vm.$systemConfig();
      commit(SET_APP_CONFIG, config);
      return config;
    },
    async queryLanguageConfig(
      { state, commit, getters, rootGetters, dispatch },
      playload
    ) {
      if (!rootGetters.sysApiCoin.cur) {
        await dispatch("querySystemConfig");
      }
      const res = await getLanguageConfig();
      if (res.data.code !== 0) {
        return;
      }
      // console.log('language', res.data.data)
      commit(SAVE_APP_LANGUAGE_CONFIG, res.data.data || []);
      return res.data.data;
    }
  }
};

export default sysDict;
